import axios from '@/common/axios'

function baseUrl(locationId) {
  return `/api/gmb/locations/${locationId}/media`
}

export function getMedia(locationId, params) {
  return axios.get(baseUrl(locationId), { params })
}

export function getMediaItem(locationId, mediaId) {
  return axios.get(`${baseUrl(locationId)}/${mediaId}`)
}

export function createMedia(locationId, formData) {
  return axios.post(baseUrl(locationId), formData)
}

export function updateMedia(locationId, mediaId, data) {
  return axios.patch(`${baseUrl(locationId)}/${mediaId}`, data)
}

export function getMediaStats(locationId) {
  return axios.get(`${baseUrl(locationId)}/stats`)
}

export function deleteMedia(locationId, mediaId) {
  return axios.delete(`${baseUrl(locationId)}/${mediaId}`)
}

export function getVideoUploadUrl(locationId, filename) {
  return axios.get(`${baseUrl(locationId)}/video_upload_url`, { params: { filename } })
}

export function extractExifs(formData) {
  return axios.post('/api/gmb/media/extract_exifs', formData)
}

export function getGalleryImages(params) {
  return axios.get('/api/images', { params })
}

export function getGalleryImageExifs(imageId) {
  return axios.get(`/api/images/${imageId}/exifs`)
}

export function uploadImageToGallery(file) {
  const formData = new FormData()
  formData.append('file', file, file.name)
  return axios.post('/api/images', formData)
}

export function previewExif({ fields, entity, entityType }) {
  return axios.post('/api/gmb/preview/exif', {
    fields,
    entity,
    entity_type: entityType
  })
}
